<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData" [pageDetailTitle]="pageDetail"></app-common-page-breadcrumbs>
<div id="loader" *ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">
    <div class="filter-nav overflow-visible border-bottom bg-light py-2">
        <div class="container visible-xs-filter-bar w-100">
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center ">
                    <div class="strong  text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
                    <div class="mr-3 picker">
                        <input name="datepicker" placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}"
                            class="form-control mobile ml-2 mt-3 filter-bar-input" #datepicker1="ngbDatepicker"
                            ngbDatepicker [displayMonths]="2" [dayTemplate]="t" [autoClose]="'outside'"
                            (dateSelect)="onDateSelection($event,datepicker1)"
                            [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
                            autocomplete="off" outsideDays="collapsed" [startDate]="startDate!"
                            (click)="toggle(datepicker1)">
                        <ng-template #t let-date let-focused="focused">
                            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                                [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                                (mouseleave)="hoveredDate = null">
                                {{ date.day }}
                            </span>
                        </ng-template>
                        <ng-template #footerTemplate>
                            <hr class="my-0">
                            <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{
                                'home.contracts.Reset' | cxTranslate }}</button>
                            <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker.close()">{{
                                'home.quote.Close'
                                | cxTranslate }}</button>
                        </ng-template>
                    </div>
                    <div class="mr-2" *ngIf="display === 'shipmentRail'">
                        <ng-select [items]="StatusList" [multiple]="true" [clearable]="false" bindLabel="name"
                            dropdownPosition="bottom" groupBy="StatusList" [selectableGroup]="false"
                            [closeOnSelect]="true" placeholder="{{'shipment.SelectStatus' | cxTranslate}}"
                            bindValue="code" [(ngModel)]="selectedStatus" notFoundText="No Items Found"
                            (change)="changeStatus()">
                            <ng-template ng-multi-label-tmp>
                                <span class="filter-count pl-2 text-black">{{selectedStatus?.length}}x
                                    {{'shipment.statusselected' | cxTranslate}}</span>
                            </ng-template>
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                <input type="checkbox" /><span class="ff-semibold "> {{'shipment.status' |
                                    cxTranslate}}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.code}}"
                                    type="checkbox" [ngModel]="item$.selected" [checked]="item.selected" />
                                <span>{{item.name}}</span>
                            </ng-template>
                        </ng-select>
                    </div>

                    <!-- <div class="mr-2" *ngIf="display === 'shipmentConsignment'">
                    <ng-select (change)="filterData()" [clearable]="false" placeholder="Select Material"
                        [dropdownPosition]="'bottom'" class="quote-status-selection filter-mobile " bindValue="id">
                        <ng-option>
                        </ng-option>
                    </ng-select>
                </div> -->
                    <div *ngIf="showClear">
                        <button type="button" class="btn btn-warning clear-text " (click)="clearFilterData()">{{
                            'home.productHeader.ClearFilter' | cxTranslate }}</button>
                    </div>

                </div>
<div class="row">

    <button *ngIf="display=='shipmentRail'" (click)="downloadShipmentReport('SHIPS_AND_DOCS_RAIL_DETAIL_REPORT')" type="button"
        class="mr-4 float-right btnheight d-none d-sm-block btn btn-secondary" href="#" role="button" id="dropdownMenuLink"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="/images/download_report.svg"
            alt="customlogo" width="25px" height="25px"> &nbsp;
        Download Report
    </button>

    <div class=" align-items-center mr-2 search-section-col">
        <div>

        </div>
        <div class="search-section-div">
            <div class="input-group d-flex align-items-center">
                <input class="form-control form-control-lg border rounded-pill input-field" type="search"
                    [(ngModel)]="searchText" (input)="search()"
                    placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
                <span class="input-group-append">
                    <button name='searchbuttondesktop'
                        class="btn btn-outline-secondary btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                        type="button">
                        <i class="fa fa-search pe-none"></i>
                    </button>
                </span>
            </div>
        </div>
    </div>
</div>
</div>
</div>


        <div class="container hidden-xs-filter-bar">
            <div class="row">
                <div class="w-100">
                    <div class="filter-select-div-mobile pl-4">
                        <div class="input-group p-2">
                            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
                               [(ngModel)]="searchText" (input)="search()"
                                placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
                            <span class="input-group-append">
                                <button name='searchbuttonfilter' class="
                      btn
                      rounded-pill
                      border-0
                      input-field
                      border-start-0 border-bottom-0 border
                      ms-n5
                    " type="button">
                                    <i class="fa fa-search mobbar"></i>
                                </button>
                                <div class='hidden-xs-filter-bar vertical ml-4'></div>
                                <div class='hidden-xs-filter-bar pr-2 pl-4' (click)='filtersidebar()'>
                                    <img class="ml-1" src="/images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                  *ngIf='length'>{{length}}</sup>
                                    <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{
                                        'home.filter.filters' |
                                        cxTranslate }}</div>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="background">
                <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
                    class="hidden-xs-filter-bar sidebar">
                    <div class='  d-flex justify-content-between p-3 border sticky'>
                        <div class="fs-24 strong pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
                        <div class="my-auto" (click)="closebar()"><img src="/images/sidebarcross.svg" alt="">
                        </div>
                    </div>
                    <div>
                        <div class="d-flex strong  pl-3 pt-3 pb-2">{{ 'home.contracts.date' | cxTranslate }}:</div>
                             <form role="form" class="date-range-picker-form ml-4">
            <div class="form-group pr-3 mb-1">
              <div class="input-group">
                <div class="input-group-prepend">

                  <input name="datepicker" class="form-control form-control-lg filter-mob"
                    placeholder="{{'home.contracts.selectdaterange' | cxTranslate }}" ngbDatepicker
                    #datepicker="ngbDatepicker" [autoClose]="'outside'"
                    (dateSelect)="onDateSelection($event,datepicker)"
                    [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
                    [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="footer" autocomplete="off"
                    outsideDays="collapsed" [startDate]="startDate!" (click)="toggle(datepicker)"
                    placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}">
                  <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                  <ng-template #footer>
                    <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{
                      'home.contracts.Reset' | cxTranslate }}</button>
                    <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker.close()">{{
                      'home.quote.Close' | cxTranslate }}</button>
                  </ng-template>
                </div>
              </div>
            </div>
          </form>
                    </div>
                    <div *ngIf="display === 'shipmentRail'">
                        <div class="d-flex strong pl-3 pt-3 pb-2">Status
                        </div>
                        <div *ngFor="let statusData of StatusList; let i=index" class=" ml-5  d-flex line-height ">
            <label *ngIf="statusData.name!==undefined && statusData.name!==''">
              <input type="checkbox" [(ngModel)]="statusData.selected" [value]="statusData.code"
                [checked]="statusData.selected" (change)="statusmobileFilter($event, statusData.code)" />
              {{statusData.code.split("_").join(" ") |titlecase}}
            </label>
          </div>
                    </div>
                    <div class="sticky-bottom p-4 border-top">
                        <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{
                            'home.contracts.seeResults'
                            |
                            cxTranslate}}</button>
                        <button class='btn btn-block' (click)="clearFilterMobile($event)">{{
                            'home.contracts.clearFilter' |
                            cxTranslate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--sort and tabs-->
    <div class="container">
        <section id="tabs" class="project-tab ipad-pro">
            <div class=" d-lg-none gird-div mb-display-top pl-3 pr-3">
                <div>
                    <span class="grid-icon css-sort ">
                        <span class="mr-2">
                            Sort by:
                        </span>
                       <select *ngIf="display === 'shipmentRail'" class="dropdownClass" [(ngModel)]="selectedSortValue"
                            (ngModelChange)="selectChangeHandler($event)">
                            <option *ngFor="let option of sortOptions" [ngValue]="option">{{option.label}}</option>
                        </select>
                        <select *ngIf="display === 'shipmentConsignment'"  class="dropdownClass-mb"
                            (change)="selectChangeHandler($event)">
                            <option value="DESC">ETAD (newest first)</option>
                            <option value="ASC">ETAD (oldest first)</option>
                        </select>

                    </span>
                </div>


            </div>
            <!-- Some CHanges -->
            <div class="row d-flex justify-content-between px-2 pt-4">
                <div class="col-lg-3 tabDiv">
                    <nav class="product-tab ">
                        <div class="nav nav-fill nav-tabs pe-auto" id="nav-tab" role="tablist">
                            <div class="nav-item nav-link  tab-bar strong" [class.active]="activeTab === 'inprogress'"
                                id="nav-home-tab" data-toggle="tab" role="tab" aria-controls="nav-home"
                                aria-selected="false" (click)="changeTab('inprogress')">{{'shipment.InProgress'|
                                cxTranslate}}
                            </div>
                            <div class="nav-item nav-link  tab-bar strong" [class.active]="activeTab === 'completed'"
                                id="nav-home-tab" data-toggle="tab" role="tab" aria-controls="nav-home"
                                aria-selected="false" (click)="changeTab('completed')">{{'shipment.Completed'|
                                cxTranslate}}
                            </div>
                        </div>
                    </nav>
                </div>
                <div class=" mobdisplay gird-div display-top mt-n1 d-none d-md-block d-lg-block-filter-bar">
                    <span *ngIf="true" class="grid-icon css-sort pr-5">
                        <span class="mr-2">
                            Sort by:
                        </span>
                        <select *ngIf="display === 'shipmentRail'" class="dropdownClass" [(ngModel)]="selectedSortValue"
                            (ngModelChange)="selectChangeHandler($event)">
                            <option *ngFor="let option of sortOptions" [ngValue]="option">{{option.label}}</option>
                        </select>
                        <select *ngIf="display === 'shipmentConsignment'" class="dropdownClass"
                          [(ngModel)]="selectedSortConsign"  (ngModelChange)="selectChangeHandler($event)">
                            <option value="DESC">ETAD (newest first)</option>
                            <option value="ASC">ETAD (oldest first)</option>
                        </select>
                    </span>
                    <span class="grid-icon ml-3">Display as: &nbsp;
                   <img class="list-icon" title="list" [src]='listSrc' (click)=" viewList()">
                   <img class="grid-icon" title="grid" [src]='gridSrc' (click)="viewGrid()">
                    </span>
                </div>

            </div>
            <div class="border-bottom"></div>
            <!-- <hr> -->
        </section>
    </div>
    <div class="container" *ngIf="list==true && 
    (activeTab === 'inprogress'||activeTab === 'completed')" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true" [infiniteScrollDisabled]="reachedToEnd === true">
        <div *ngIf="railList && railList.length === 0 && !enableLoader && display === 'shipmentRail'"
            class="text-center strong  text-secondary my-5">
            {{'home.contracts.Noresults' | cxTranslate }}</div>
        <div *ngIf="shipConsignList && shipConsignList.length === 0 && !enableLoader && display === 'shipmentConsignment'"
            class="text-center strong  text-secondary my-5">
            {{'home.contracts.Noresults' | cxTranslate }}</div>
        <!--for rail list view-->

        <div class="row flex-wrap" *ngIf="display === 'shipmentRail'&& railList?.length>0 ">
            <div class="col-md-12 col-lg-12 " *ngFor="let raildata of railList; ">
                <div class="card mt-4 mb-4 card-border border-radius-05">
                    <div class="card-body pb-0 pt-4 ">
                        <div class="d-flex d-none d-md-block d-lg-block col-md-2">
                            <div class="badge " [ngClass]="raildata?.statusCode=='DEPARTED'?'badge-departed':raildata?.statusCode=='SENT_FOR_SCHEDULING'?
                                'badge-secondary':raildata?.statusCode=='SCHEDULED'?'badge-scheduled':raildata?.statusCode=='ARRIVED_AT_DESTINATION'?
                                'badge-purple':raildata?.statusCode=='CONFIRMED'?'badge-success':''">
                                {{raildata.status}}</div>
                               
                        </div>
                        <hr>
                        <div class='d-flex py-2 text-break'>
                            <div class="d-none d-md-block d-lg-block col-md-2">
                                <span class="h4 mb-0 fw-bold">Rail</span><span class="h5"> (Shipment no)</span>
                                <div class=" text-secondary">{{raildata.railNumber}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2 text-nowrap">
                                <div class=" text-secondary">Destination</div>
                                <div class=" text-black text-wrap">{{raildata.destination}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2">
                                <div class=" text-secondary">Total schedule qty {{raildata.scheduledQuantityInSalesUnit?'('+raildata.scheduledQuantityInSalesUnit+')' :''}}</div>
                                <div class=" text-black">{{raildata.totalScheduleQty}}</div>
                            </div>

                            <div class="d-none d-md-block d-lg-block col-md-2">
                                <div class=" text-secondary">Total actual qty {{raildata.actualQuantityInSalesUnit?'('+raildata.actualQuantityInSalesUnit+')' :''}}</div>
                                <div class=" text-black">{{raildata.totalActualQty}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-1">
                                <div class=" text-secondary text-nowrap">Rail cars (nos)</div>
                                <div class=" text-black">{{raildata.railCars}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-1">
                                <div class=" text-secondary">ETDS</div>
                                <div class=" text-black text-nowrap">{{raildata.formattedEtds}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-1">
                                <div class=" text-secondary">ATDS</div>
                                <div class=" text-black text-nowrap">{{raildata.formattedAtds}}</div>
                            </div>

                            <div class="d-none d-md-block d-lg-block col-md-1">
                                <div class=" text-secondary">ETAD</div>
                                <div class=" text-black text-nowrap">{{raildata.formattedEtad}}</div>
                            </div>

                        </div>
                        <div class="hr mt-0 my-3 d-none d-md-block d-lg-block "></div>
                        <div class=" ml-3 mb-3 d-flex justify-content-between d-none d-md-block d-lg-block">
                            <div class="mt-2 d-none d-md-block d-lg-block">
                                <div class="strong text-primary pe-auto" (click)="gotoDeatils(raildata)">
                                    View documents and details ></div>
                            </div>
                        </div>
                    </div>
                    <!--mobile view-->
                    <div class=" container py-4 d-lg-none">
                        <div class="ml-2 d-flex justify-content-between">
                            <div class="h5 mb-0 fw-bold">Rail</div>
                            <div class="small text-secondary">{{raildata.railNumber}}</div>

                        </div>
                    </div>
                    <!-- End  -->

                    <!-- Mobile View Active/Completed tab -->
                        <!-- <div class="d-flex ml-3 d-lg-none">
                            <div  class="badge " [ngClass]="raildata.statusCode=='DEPARTED'?'badge-departed':raildata.statusCode=='SENT_FOR_SCHEDULING'?
                                'badge-secondary':raildata.statusCode=='SCHEDULED'?'badge-scheduled':'badge-success'">
                                {{raildata.status}}</div>
                               
                        </div> -->
                    <div class="  hr mt-0 mb-0 d-lg-none"></div>
                    <div class="container py-2 d-lg-none">
                        <div class="d-flex mb-3  justify-content-between">
                            <div class=" strong text-secondary">Destination</div>
                            <div class="bold text-black">{{raildata.destination}}</div>
                        </div>

                        <div class="d-flex mb-3  justify-content-between">
                            <div class="small strong text-secondary">Total schedule qty {{raildata.scheduledQuantityInSalesUnit?'('+raildata.scheduledQuantityInSalesUnit+')' :''}}</div>
                            <div class="small text-white badge">{{raildata.totalScheduleQty}}</div>
                        </div>
                        <div class="d-flex mb-3  justify-content-between">
                            <div class="small strong text-secondary">Total actual qty  {{raildata.actualQuantityInSalesUnit?'('+raildata.actualQuantityInSalesUnit+')' :''}} </div>
                            <div class="small text-white badge">{{raildata.totalActualQty}}</div>
                        </div>
                        <div class="d-flex mb-3  justify-content-between">
                            <div class=" strong text-secondary">No. rail car</div>
                            <div class=" text-black">{{raildata.railCars}}</div>
                        </div>
                        <div class="d-flex mb-3  justify-content-between">
                            <div class=" strong text-secondary">ETDS</div>
                            <div class=" text-black">{{raildata.formattedEtds}}</div>
                        </div>
                        <div class="d-flex mb-3  justify-content-between">
                            <div class=" strong text-secondary">ATDS</div>
                            <div class=" text-black">{{raildata.formattedAtds}}</div>
                        </div>

                        <div class="d-flex mb-3  justify-content-between">
                            <div class=" strong text-secondary">ETAD</div>
                            <div class=" text-black">{{raildata.formattedEtad}}</div>
                        </div>

                    </div>
                    <div class="hr mt-0 mb-3 d-lg-none"></div>
                    <div class="ml-3 mb-3 d-flex justify-content-between d-lg-none">
                        <div class="mt-2">
                            <div class="strong text-primary pe-auto" (click)="gotoDeatils(raildata)">
                                View documents and details ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--for consignment list view-->
        <div class="row flex-wrap" *ngIf="display === 'shipmentConsignment'">
            <div class="col-md-12 col-lg-12 " *ngFor="let shipconsigndata of shipConsignList ">
                <div class="card mt-4 mb-4 card-border border-radius-05">
                    <div class="card-body pb-0 pt-3 pl-0">
                        <div class='d-flex py-2 text-break'>
                            <div class="d-none d-md-block d-lg-block col-md-2">
                                <div class="h5 mb-0 fw-bold">Consignment</div>
                                <div class="small text-secondary">{{shipconsigndata.consignmentNumber}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2 ">
                                <div class="small text-secondary">Destination</div>
                                <div class="small text-black">{{shipconsigndata.shippingDestination}}</div>
                            </div>

                            <div class="d-none d-md-block d-lg-block col-md-2">
                                <div class="small text-secondary">Material</div>
                                <div class="small text-black">{{shipconsigndata.materialDescription}}</div>
                            </div>

                            <div class="d-none d-md-block d-lg-block col-md-1 text-nowrap">
                                <div class="small text-secondary">Quantity {{shipconsigndata.actualQtyUnit?'('+shipconsigndata.actualQtyUnit+')' :''}}</div>
                                <div class="small text-black">{{shipconsigndata.quantity}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2">
                                <div class="small text-secondary">Contract ID</div>
                                <div class="small text-black">{{shipconsigndata.contractID}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-1">
                                <div class="small text-secondary">ETAD</div>
                                <div class="small text-black">{{shipconsigndata.etadDate}}</div>
                            </div>
                            <div class="d-none d-md-block d-lg-block col-md-2" *ngIf="shipconsigndata.purchaseOrderNo"> 
                                <div class="small text-secondary">External reference no</div>
                                <div class="small text-black">{{shipconsigndata.purchaseOrderNo}}</div>
                            </div>
                        </div>
                        <div class="hr mt-0 my-3 d-none d-md-block d-lg-block "></div>
                        <div class="ml-3 mb-3 d-flex justify-content-between d-none d-md-block d-lg-block">
                            <div class="mt-2 d-none d-md-block d-lg-block">
                                <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipconsigndata)">
                                    View documents and details ></div>
                            </div>
                        </div>

                    </div>
                    <!--mobile view-->
                    <div class=" container py-4 d-lg-none">
                        <div class="d-flex justify-content-between">
                            <div class="h5 mb-0 fw-bold">Consignment</div>
                            <div class="small text-secondary">{{shipconsigndata.consignmentNumber}}</div>
                        </div>
                    </div>
                    <!-- End  -->

                    <!-- Mobile View Active/Completed tab -->
                    <div class="  hr mt-0 mb-0 d-lg-none"></div>
                    <div class="container py-2 d-lg-none">
                        <div class="d-flex mb-3  justify-content-between">
                            <div class="small strong text-secondary">Material</div>
                            <div class="small text-black">{{shipconsigndata.materialDescription}}</div>
                            </div>
                            <div class="d-flex mb-3  justify-content-between">
                                <div class="small strong text-secondary">Destination</div>
                                <div class="small text-black ">{{shipconsigndata.shippingDestination}}</div>
                            </div>
                            <div class="d-flex mb-3  justify-content-between">
                                <div class="small strong text-secondary">ETAD</div>
                                <div class="small text-black ">{{shipconsigndata.etadDate}}</div>
                            </div>
                            <div class="d-flex mb-3  justify-content-between">
                                <div class="small strong text-secondary">Quantity {{shipconsigndata.actualQtyUnit?'('+shipconsigndata.actualQtyUnit+')' :''}}</div>
                                <div class="small text-black ">{{shipconsigndata.quantity}}</div>
                            </div>
                            <div class="d-flex mb-3  justify-content-between">
                                <div class="small strong text-secondary">Contract ID</div>
                                <div class="small text-black ">{{shipconsigndata.contractID}}</div>
                            </div>
                            <div class="d-flex mb-3  justify-content-between" *ngIf="shipconsigndata.purchaseOrderNo">
                                <div class="small strong text-secondary">External reference no</div>
                                <div class="small text-black ">{{shipconsigndata.purchaseOrderNo}}</div>
                            </div>
                        </div>
                        <div class="hr mt-0 mb-3 d-lg-none"></div>
                        <div class="ml-3 mb-3 d-flex justify-content-between d-lg-none">
                            <div class="mt-2">
                                <div class="strong text-primary pe-auto" (click)="gotoDeatils(shipconsigndata)">
                                    View documents and details ></div>
                            </div>
                        </div>
                </div>
            </div>
        </div>

        <!--end consignment list view-->

    </div>

    <!--for grid-->
    <div class="container" *ngIf="grid==true && (activeTab === 'inprogress'||activeTab === 'completed')" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true" [infiniteScrollDisabled]="reachedToEnd === true">
        <div class="row flex-wrap" *ngIf="display === 'shipmentRail'">
            <div class="col-md-6 col-lg-4 " *ngFor="let raildata of railList; ">
                <div class="card card-body mt-4 mb-4 p-3 border-radius-05">
                    <div class="d-flex">
                       <div  class="badge " [ngClass]="raildata.statusCode=='DEPARTED'?'badge-departed':raildata.statusCode=='SENT_FOR_SCHEDULING'?
                                'badge-secondary':raildata.statusCode=='SCHEDULED'?'badge-scheduled':'badge-success'">
                                {{raildata.status}}</div>
                    </div>
                    <hr>
                    <div>
                        <div class="d-flex">
                            <img src="/images/train.svg" alt="icon" width="42" height="44">
                            <ul>
                                <li class="strong h5 mb-0">Rail</li>
                                <li class="small text-secondary small">
                                    {{raildata.railNumber}}</li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="small text-secondary small">Destination</div>
                                <div class="strong small itenerary-location">{{raildata.destination}}</div>
                            </div>
                            <div class="col">
                                <div class="small text-secondary small">Total Scheduled quantity ({{raildata.scheduledQuantityInSalesUnit}})</div>
                                <div class="strong small itenerary-location">{{raildata.totalScheduleQty}}</div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row d-flex flex-wrap justify-content-between">
                        <div class="col dates">
                            <div class="small text-secondary small">Total actual qty ({{raildata.actualQuantityInSalesUnit}})</div>
                            <div class=" small">{{raildata.totalActualQty}}</div>
                        </div>
                        <div class="col dates">
                            <div class="small text-secondary small">No. rail cars</div>
                            <div class="small">{{raildata.railCars}}</div>
                        </div>
                        <div class="col dates">
                            <div class="small text-secondary small">ETDS</div>
                            <div class="small">{{raildata.formattedEtds}}</div>
                        </div>
                        <div class="col dates">
                            <div class="small text-secondary small">ETAD</div>
                            <div class="small">{{raildata.formattedEtad}}</div>
                        </div>
                    </div>
                    <hr>
                    <div>
                        <div class="btn btn-link p-0  float" (click)="gotoDeatils(raildata)">
                            {{'shipment.documents&Details' |
                            cxTranslate}} ></div>
                    </div>
                </div>
            </div>
        </div>
        <!--for onsignment grid view-->
        <div class="row flex-wrap">
            <div class="col-md-6 col-lg-4 " *ngFor="let shipconsigndata of shipConsignList ">
                <div class="card card-body mt-4 mb-4 p-3 border-radius-05">

                    <div>
                        <div class="d-flex">
                            <img src="/images/warehouse.svg" alt="icon" width="42" height="44">
                            <ul>
                                <li class="strong h5 mb-0">Consignment</li>
                                <li class="small text-secondary small">
                                    {{shipconsigndata.consignmentNumber}}</li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="small text-secondary small">Material</div>
                                <div class="strong small itenerary-location">{{shipconsigndata.materialDescription}}
                                </div>
                            </div>
                            <div class="col">
                                <div class="small text-secondary small">Destination</div>
                                <div class="strong small itenerary-location">{{shipconsigndata.shippingDestination}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row d-flex flex-wrap justify-content-between">
                        <div class="col dates">
                            <div class="small text-secondary small">ETAD</div>
                            <div class=" small">{{shipconsigndata.etadDate}}</div>
                        </div>
                        <div class="col dates">
                            <div class="small text-secondary small">Quantity {{shipconsigndata.actualQtyUnit?'('+shipconsigndata.actualQtyUnit+')' :''}}</div>
                            <div class="small">{{shipconsigndata.quantity}}</div>
                        </div>
                        <div class="col-6 dates">
                            <div class="small text-secondary small">Contract ID</div>
                            <div class="small">{{shipconsigndata.contractID}}</div>
                        </div>
                         <div class="col mt-4 dates" *ngIf="shipconsigndata.purchaseOrderNo">
                            <div class="small text-secondary small">External reference no</div>
                            <div class="small">{{shipconsigndata.purchaseOrderNo}}</div>
                        </div>
                    </div>
                    <hr>
                    <div>
                        <div class="btn btn-link p-0  float" (click)="gotoDeatils(shipconsigndata)">
                            {{'shipment.documents&Details' |
                            cxTranslate}} ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>